import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, ViewChild, ViewContainerRef } from '@angular/core';
import { LayerService } from 'src/app/features/map-features/sections/locations-section/services/Layers.service';
import { LocationsMapService } from 'src/app/features/map-features/sections/locations-section/services/LocationsMap.service';
import { NavHeaderService } from 'src/app/features/ui/organisms/header/service/nav-header.service';
import { LocalStorageService } from 'src/app/features/shared/services/LocalStorage.service';
import { MAP_BUILD_NAMES } from 'src/models/common/EnumMapas';
import { InfoBoxMapService } from 'src/services/maps/features/InfoBox-Map.service';
import { ToolCarsSelectorService } from '../../services/Tool-Cars-Selector.service';
import { FULL_TOOLS_ALLOWED, ToolsEnum } from '../../utils/enums/toolsEnum';
import { AllowedDTO } from '../../utils/models/allowedDTO';
import { PanelLocationsService } from 'src/app/features/map-features/sections/locations-section/services/Panel-Locations.service';
import { DetailsPanelAllowanceEnum } from '../../utils/enums/detailsPanelAllowanceEnum';
import { MapRestrictionsService } from '../../services/MapRestrictions.service';
import { EnumLocationCategories } from 'src/app/features/shared/helpers/enums/EnumLocationCategories';
import { LocationCategoryDTO } from 'src/app/features/map-features/sections/locations-section/models/LocationCategoryDTO';
import { RouteSheetUtilService } from 'src/app/features/map-features/ui/organisms/route-sheet/service/RouteSheetUtil.service';

@Component({
  selector: 'app-ticket-map',
  templateUrl: './ticket-map.component.html',
  styleUrls: ['./ticket-map.component.css']
})
export class TicketMapComponent {
  allowedParts: AllowedDTO = { 
      allowedTools: [
        ToolsEnum.layersPanel,
        ToolsEnum.internalLayersPanel,
        ToolsEnum.externalLayersPanel,
        ToolsEnum.mapLayersPanel,
    
        ToolsEnum.geocoder, 
        ToolsEnum.reposition,
        // ToolsEnum.carSelector,
        // ToolsEnum.streetInfo,
        ToolsEnum.annotationsLayer
      ],
      allowedCategories: [],
      allowedFeaturesDetailsPanel: [
        DetailsPanelAllowanceEnum.movementReport
      ]
    };
  
    @ViewChild('dynamicComponentContainer', { read: ViewContainerRef, static: true })
    carouselViewContainerRef!: ViewContainerRef;
  
    selectedPanel: any;
  
    //Variables para tooltip
    intersectMsg: string = "Selecciona varios puntos en el mapa para crear la SELECCIÓN DE UNIDADES. Para finalizar da click derecho sobre el mapa.";
  
    mobileQuery: MediaQueryList;
    private _mobileQueryListener: () => void;
  
    MAP_BUILD_NAMES: any = MAP_BUILD_NAMES;
  
    constructor(
      private locationsMapService: LocationsMapService,
      private panelLocationsService: PanelLocationsService,
      private routeSheetUtilService: RouteSheetUtilService,
      private navHeaderService: NavHeaderService,
      public infoBoxMapService: InfoBoxMapService,
      public toolCarSelectorService: ToolCarsSelectorService,
      public localStorageService: LocalStorageService,
      media: MediaMatcher,
      changeDetectorRef: ChangeDetectorRef,
      public layerService: LayerService,
      private mapRestrictionsService: MapRestrictionsService
    ) {
      this.mobileQuery = media.matchMedia("(min-width: 761px)");
      this._mobileQueryListener = () => changeDetectorRef.detectChanges();
      this.mobileQuery.addListener(this._mobileQueryListener);
  
    }
  
    ngOnInit() {
      this.checkAllowedCategories();
      this.mapRestrictionsService.allowedParts$.next(this.allowedParts);
  
      //añadir cosas el unified
      this.InitialiceMapComponents();
  
    }
  
    ngAfterViewInit(): void {
    }
  
    onToolTipVisibilityChange(isVisible: boolean) {
      this.toolCarSelectorService.isCarSelectionToolTipVisible = isVisible;
    }
  
    InitialiceMapComponents() {
      this.locationsMapService.setCarouselViewContainerRef(this.carouselViewContainerRef);
      this.routeSheetUtilService.setCarouselViewContainerRef(this.carouselViewContainerRef);
    }
  
    checkAllowedCategories(){
      const params = JSON.parse(localStorage.getItem("queryParams") || "{}");
      this.allowedParts.allowedCategories = params['idCategories'] ? params['idCategories'].split(',') : [];
  
      // if(this.allowedParts.allowedCategories.length === 0){
      //   const categories = JSON.parse(this.localStorageService.getListaCategorias() || "[]");
      //   // this.allowedParts.allowedCategories = categories.map((cat: any) => cat.id.toString());
      //   this.allowedParts.allowedCategories.push("6");
      //   this.allowedParts.allowedCategories.push("2");
      // }
      if(this.allowedParts.allowedCategories.length === 0){
        const categories = JSON.parse(this.localStorageService.getListaCategorias() || "[]") as LocationCategoryDTO[];
        const mainIdCategory = categories.find((cat: LocationCategoryDTO) => cat.name == EnumLocationCategories.Service)?.id;
        const extraIdCategory = categories.find((cat: LocationCategoryDTO) => cat.name == EnumLocationCategories.Engineer)?.id;
        
        this.allowedParts.allowedCategories.push(mainIdCategory.toString() || "6");
        this.allowedParts.allowedCategories.push(extraIdCategory?.toString() || "2");
      }
      this.panelLocationsService.canClosePanel.next(false);
    }

}
